<template>
  <div>
    <MainTitle title="Base de Datos" description="Integración de tableros de datos" />
    
    <div class="container m-b-1_5">
      <DownloadData
        file="descargables/datos/cultivos_criticos_glifosato.zip"
        type="application/zip"
        format="zip"
        color="cultivo"
        name="Distribución nacional de cultivos críticos con uso de glifosato"
        downloadname="distribucion-nacional-de-cultivos-citricos-con-uso-de-glifosato.zip"
        weight="53 KB" />
      <DownloadData
        file="descargables/datos/maquinaria_agricola.zip"
        type="application/zip"
        format="zip"
        color="maquinaria"
        name="Maquinaria, tracción animal y equipo manual para el trabajo agrícola"
        downloadname="maquinaria-agricola.zip"
        weight="167 KB" />
      <DownloadData
        file="descargables/datos/uso_herbicidas.zip"
        type="application/zip"
        format="zip"
        color="herbicidas"
        name="Uso de herbicidas"
        downloadname="uso-de-herbicidas.zip"
        weight="191 KB" />
    </div>    
  </div>
</template>


<script>
import MainTitle from '@/components/MainTitle.vue'
import DownloadData from '@/components/DownloadData'

export default {
  name: 'Repositorio',
  components: {
    MainTitle,
    DownloadData
  }
}
</script>

<style scoped lang="scss">
.m-b-1_5 {
  @media (min-width: $breakpoint-tablet) {
    margin-bottom: $space * 1.5;
  }
}
</style>